module.exports = new __parcel__URL__("Mkt Plan.51fd454e.svg").toString();